import React from 'react';
import { connect } from 'react-redux';

import * as MediaActions from "../../data/media/MediaActions";

import MediaCard from './MediaCard';

const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
    removeMedia: MediaActions.removeMedia,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MediaCard);
